import { FormLabel, type FormLabelProps } from '@/ui';

export const Label = (props: FormLabelProps) => {
  return <FormLabel fontSize="lg" fontWeight="medium" {...props} />;
};
